export const CUSTOMER_REVIEW_MODAL = 'CustomerReviewModal';
export const TOGGLE_LABEL = 'Allow Review Submission';
export const DISABLED_TOGGLE_TOOLTIP_MESSAGE =
  'Feature not available. Contact Fisherman support to update your site';
